import genericApi from './genericApi';
import ApiResponse from '../models/ApiResponse';
import { baseUrl } from './baseUrl';

const signatureRequestHandler = {

  saveSignature: (poNumber: string, signature: string, returned: boolean, returnedOptions: { code?: string, number?: string, version?: string }, type?: string, remarks?: string): Promise<ApiResponse<boolean>> => {
    let url = `pickup_order/${poNumber}/signature?`;
    if (returned)
      url += `returned=true&`;
    if (type) {
      url += `type=${type}&`;
    }
    let body = { signature, remarks: '' }
    if(remarks) {
      body = {...body, remarks}
    }

    if (returnedOptions.code)
      url += `awb_code=${returnedOptions.code}&awb_number=${returnedOptions.number}&awb_version=${returnedOptions.version}`;

    return genericApi.put(url, body);
  },

  saveOfflineSignature: (poNumber: string, signature: string, returned: boolean, returnedOptions: { code?: string, number?: string }): Promise<ApiResponse<boolean>> => {
    let url = `offline_order/${poNumber}/signature?`;
    if (returned)
      url += `returned=true&`;
    if (returnedOptions.code)
      url += `awb_code=${returnedOptions.code}&awb_number=${returnedOptions.number}`;
    return genericApi.put(url, { signature });
  },

  constructSignatureUrl: (poNumber: string, returnedOptions: { code?: string, number?: string }): string => {
    let url = `${baseUrl}pickup_order/${poNumber}`;
    if (returnedOptions.code && returnedOptions.number)
      url += `/awb/${returnedOptions.code}/${returnedOptions.number}`;

    url += `/signature`;
    return url;
  },

  constructOfflineSignatureUrl: (poNumber: number, returnedOptions: { code?: string, number?: string }): string => {
    let url = `${baseUrl}offline_order/${poNumber}`;
    if (returnedOptions.code && returnedOptions.number)
      url += `/awb/${returnedOptions.code}/${returnedOptions.number}`;

    url += `/signature`;
    return url;
  }

};

export default signatureRequestHandler;